import { format } from 'date-fns';
import moment from 'moment';

export function sqlDateStr(dt: Date): string {
  if (dt) {
    return format(dt, 'yyyy-MM-dd');
  } else {
    return '';
  }
}

export function sqlDateTimeStr(dt: Date): string {
  if (dt) {
    return format(dt, 'yyyy-MM-dd HH:mm:ss SSS');
  } else {
    return '';
  }
}

// Όταν απο το UI πάς σε SQL πρέπει να μετασχηματίσεις σε UTC
// 1/1/2020 -> 31/12/2019 21:00
export function sqlDateTimeUtcStr(dt: Date): string {
  if (dt) {
    return moment.utc(dt).format('YYYY-MM-DD HH:mm:ss SSS');
  } else {
    return '';
  }
}

export function addToWhereClause(
  prvpart: string,
  newpart: string,
  operation = 'AND'
): string {
  if (prvpart && prvpart !== '')
    return `${prvpart}\n ${operation} (${newpart})`;
  else return `(${newpart})`;
}

export function splitGmtFromDate(dt: Date) {
  return dt.toString().split('GMT')[0];
}

export function sqlDatePeriodWhereClause(
  fieldName: string,
  startDT: Date,
  endDT: Date,
  runningAt: 'SERVER' | 'CLIENT' = 'SERVER'
): string {
  const datetimeToStrFunc =
    runningAt === 'SERVER' ? sqlDateTimeUtcStr : sqlDateTimeStr;
  return `((${fieldName} >= '${datetimeToStrFunc(
    startDT
  )}') AND (${fieldName} <= '${datetimeToStrFunc(endDT)}'))`;
}
